import { render, staticRenderFns } from "./kindsEdit.vue?vue&type=template&id=52f5d5a7&scoped=true&"
import script from "./kindsEdit.vue?vue&type=script&lang=js&"
export * from "./kindsEdit.vue?vue&type=script&lang=js&"
import style0 from "./kindsEdit.vue?vue&type=style&index=0&id=52f5d5a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5d5a7",
  null
  
)

export default component.exports